"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _reactRouterDom = require("react-router-dom");
var _chevron = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/chevron.svg"));
var _excluded = ["classes", "className", "to", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type Node } from 'react';*/ /*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: _objectSpread(_objectSpread({}, theme.typography.header5), {}, {
      color: theme.colors.porpoise,
      float: 'right',
      textTransform: 'none',
      paddingRight: '1rem',
      background: "url(".concat(_chevron.default, ") 100% 100% no-repeat"),
      backgroundSize: '1rem'
    })
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  children: Node,
  to: string
};*/
var PaneLink = function PaneLink(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    to = _ref /*:: */.to,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/ /*: Node*/_react.default.createElement(_reactRouterDom.Link, (0, _extends2.default)({
    to: to,
    className: (0, _classnames.default)(classes.root, className)
  }, props));
};
PaneLink.displayName = 'PaneLink';
var _default = exports.default = (0, _injectSheet.default)(Style)(PaneLink);
//# sourceMappingURL=PaneLink.js.map